import styled from 'styled-components';
import ServiceTag, { SKINS } from './ServiceTag';

export default styled(ServiceTag)`
  border: none;

  &.${SKINS.white} {
    color: var(--grey700);
    background-color: var(--grey100);
  }
  &.${SKINS.grey} {
    color: var(--grey800);
    background-color: var(--grey200);
  }
  &.${SKINS.primary} {
    color: var(--primary900);
    background-color: var(--primary100);
  }
  &.${SKINS.accent} {
    color: var(--accent900);
    background-color: var(--accent100);
  }
  &.${SKINS.success} {
    color: var(--success900);
    background-color: var(--success100);
  }
  &.${SKINS.error} {
    color: var(--error-900);
    background-color: var(--error-100);
  }
  &.${SKINS.deepPurple} {
    color: var(--deep-purple900);
    background-color: var(--deep-purple100);
  }
  &.${SKINS.lhExpress} {
    color: var(--grey100);
    background-color: var(--greenKiwiText);
  }
  &.${SKINS.userTypeSystem} {
    color: var(--grey900);
    background-color: var(--grey200);
  }
  &.${SKINS.userTypeInternal} {
    color: var(--primary900);
    background-color: var(--primary50);
  }
  &.${SKINS.userTypeCrossdock} {
    color: var(--white);
    background-color: var(--deep-purple900);
  }
  &.${SKINS.userTypeShipper} {
    color: var(--white);
    background-color: var(--success700);
  }
  &.${SKINS.userTypeCarrier} {
    color: var(--white);
    background-color: var(--primary700);
  }
`;

export const TagGroup = styled.div`
  display: flex;

  > * {
    border-radius: 0;
  }

  > *:first-child {
    border-radius: 0.2rem 0 0 0.2rem;
  }

  > *:last-child {
    border-radius: 0 0.2rem 0.2rem 0;
  }

  > *:first-child:last-child {
    border-radius: 0.2rem;
  }
`;
